export function OutlineVistaIndefinidaIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3136 3H4.6512C3.73927 3 3 3.73927 3 4.6512V5.2032C3 6.11513 3.73927 6.8544 4.6512 6.8544H8.3136C9.22553 6.8544 9.9648 6.11513 9.9648 5.2032V4.6512C9.9648 3.73927 9.22553 3 8.3136 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.10229 9.93555H7.8479"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46582 6.85352V9.93512"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3151 3H15.6527C14.7407 3 14.0015 3.73927 14.0015 4.6512V5.2032C14.0015 6.11513 14.7407 6.8544 15.6527 6.8544H19.3151C20.227 6.8544 20.9663 6.11513 20.9663 5.2032V4.6512C20.9663 3.73927 20.227 3 19.3151 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0991 9.93555H18.8495"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4673 6.85352V9.93512"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.981 18L11.9666 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9807 12V14.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 21L10.9632 12H12.912L20.9664 21"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
